const POS_ENUMS = {
  DELIVERECT: 'deliverect',
  OCIMS: 'ocims',
};

export default POS_ENUMS;
